import { useLocation } from "@reach/router"
import { Fragment, useEffect } from "react"

import { trackingClient } from "@trueskin-web/apis"
import {
  QuestionnaireIdUrl,
  ResetCache,
  UrlLocaleSwitcher,
  VoucherUrl,
} from "@trueskin-web/components"
import { storageService } from "@trueskin-web/services"

import Header from "./header"

const storageKeys = storageService.getStorageKeys()
const testPresetsToCleanUp = [
  "anti_ageing_ab_test",
  "anti_aging_AG_436_exp_V2",
  "anti_aging_AG_436_exp_V1",
  "main_xl_AG_452_sub_tiers_exp_V2",
  "main_xl_AG_356_exp_V1",
]

const Layout = ({ children, dataTestId, enableConfirmation }) => {
  const location = useLocation()

  useEffect(() => {
    trackingClient.trackTouchPoint(location)
    // TODO: temporary fix, refactor later, we need proper cleanup of deactivated VWO tests
    const testPreset = storageService.getItem({
      id: storageKeys.VWO_TEST_PRESET_TYPE,
    })

    if (testPresetsToCleanUp.includes(testPreset)) {
      storageService.removeItem({ id: storageKeys.VWO_TEST_PRESET_TYPE })
    }
  }, [location])

  return (
    <Fragment>
      <ResetCache />

      <VoucherUrl />

      <QuestionnaireIdUrl />

      <UrlLocaleSwitcher />

      <Header enableConfirmation={enableConfirmation} />

      <main data-testid={dataTestId}>
        <section>{children}</section>
      </main>
    </Fragment>
  )
}

export default Layout
